module.exports = __webpack_public_path__ + "static/media/DiplomacyMap.8c9a24bf.svg";